module.exports = __webpack_public_path__ + "static/img/oruro.644fd28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/departamentales/oruro.jpg
// module id = dyGi
// module chunks = 1